import { useMemo } from "react";
import { useLockDate } from "../api/lock.api";
import { isLocked } from "../helpers/lock";

export function useIsDateLocked(entityId: number | null, date?: Date) {
    const lockDate = useLockDate(entityId);
    return useMemo(() => isLocked(lockDate, date), [date, lockDate]);
}
